<template>
  <modal name="tarefaInfo" height="auto" width="1024" :scrollable="true" :clickToClose="true">
    <CloseModal :close="close" />
    <div class="modalbox">
      <div class="modalbox-content">
        <CTabs variant="tabs" class="nav-tabs-boxed">
          <CTab title="Última sincronização">
            <UltimaCarga :tarefa="tarefa" />
          </CTab>
          <CTab title="Histórico de sincronizações">
            <LogUltimasCargas :tarefa="tarefa" />
          </CTab>
        </CTabs>
      </div>
    </div>
    <div class="modal-footer modal-footer--carga">
      <button class="button" v-on:click="close">Fechar</button>
      <button class="button button-success" v-on:click="syncTarefa(tarefa)">
        <fa-icon icon="sync" /> Sincronizar
      </button>
      <button class="button button-primary" v-on:click="loadTarefas">
        <fa-icon icon="sync-alt" /> Atualizar
      </button>
    </div>
  </modal>
</template>
<script>
import CloseModal from "../../components/CloseModal";
import UltimaCarga from './CargaInfo/UltimaCarga';
import LogUltimasCargas from './CargaInfo/LogUltimasCargas';

export default {
  name: "tarefaInfo",
  props: [
    "close",
    "tarefa",
    "descricao",
    "loadTarefas",
    "syncTarefa"
  ],
  components: {
    CloseModal,
    UltimaCarga,
    LogUltimasCargas
  }
};
</script>

<style scoped>
/* Rodapé do modal de info: ações alinhadas à direita, no padrão VersoTech */
.modal-footer--carga {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  border-bottom: none;
}

.modal-footer--carga .button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 0;
  border-radius: 6px;
}
</style>
